const words = ["Pickup", "Count", "Wash", "Fold", "Press", "Deliver", "Notify"];

export default function Marquee() {
  return (
    <section aria-hidden="true" data-testid="editorial-marquee" className="bg-[#0F2B3E] py-7 overflow-hidden border-y border-white/5 select-none">
      <div className="marquee-track flex w-max whitespace-nowrap">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center">
            {words.map((w, i) => (
              <span key={i} className="flex items-center">
                <span className={`font-display text-3xl sm:text-5xl font-extrabold tracking-tight px-7 ${i % 2 === 0 ? "text-white" : "text-transparent"}`} style={i % 2 === 1 ? { WebkitTextStroke: "1.5px #AED6F1" } : undefined}>
                  {w}
                </span>
                <span className="w-2.5 h-2.5 rounded-full bg-[#1ABC9C] shrink-0" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
}
